import { render, staticRenderFns } from "./Artwork.vue?vue&type=template&id=1f2264bf&"
import script from "./Artwork.vue?vue&type=script&lang=js&"
export * from "./Artwork.vue?vue&type=script&lang=js&"
import style0 from "./Artwork.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports